// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 977 ? "summary" : chunkId) + "." + {"332":"c3a3a55f","838":"d6341669","977":"a1b2c06a"}[chunkId] + ".js";
};